var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.publisherWarnings.length)?_c('v-icon',{staticClass:"mx-2",attrs:{"small":"","color":"warning"}},[_vm._v(" mdi-alert-outline ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }